import React, { useState } from 'react';

const SizeChartModal = ({ isOpen, toggleModal }) => {
  const [unit, setUnit] = useState('inch');

  const toggleUnit = (unitType) => {
    setUnit(unitType);
  };

  return (
    <div
      className={`modal fade flat-modal-ui size-chart-modal ${isOpen ? 'show' : ''}`}
      id="sizeChartModal"
      tabIndex="-1"
      style={isOpen ? { display: 'block' } : {}}
      aria-hidden={!isOpen}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="unset close-btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={toggleModal}
            >
              <i data-feather="x" className="icon-black cursor-pointer"></i>
            </button>

            {/* Unit Toggle Buttons */}
            <div className="text-center mt-3 mb-4">
              <div className="btn-group" role="group" aria-label="Unit Toggle">
                <button
                  type="button"
                  className={`btn btn-primary ${unit === 'inch' ? 'active' : ''}`}
                  onClick={() => toggleUnit('inch')}
                >
                  Inches
                </button>
                <button
                  type="button"
                  className={`btn btn-primary ${unit === 'cm' ? 'active' : ''}`}
                  onClick={() => toggleUnit('cm')}
                >
                  Centimeters
                </button>
              </div>
            </div>

            {/* Suit Size Chart */}
            <div className="sc-card mt-3">
              <div className="sc-card-header">
                <h4>CANDIDMEN SUIT SIZE CHART</h4>
              </div>
              <div className="sc-card-body text-center">
                <p className="fs-14 fw-500">
                  Sizes Mentioned In (<span className="unit-text">{unit === 'inch' ? 'Inches' : 'Centimeters'}</span>)
                </p>

                <div className="table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Size</th>
                        <th>Chest</th>
                        <th>Waist</th>
                        <th>Neck</th>
                        <th>Sleeve</th>
                      </tr>
                    </thead>
                    <tbody className={unit === 'inch' ? 'inch-values' : 'cm-values'}>
                      {unit === 'inch' ? (
                        <>
                          <tr><td><b>XS</b></td><td>32 - 34</td><td>26 - 28</td><td>13 - 13.5</td><td>31 - 32</td></tr>
                          <tr><td><b>S</b></td><td>35 - 37</td><td>29 - 31</td><td>14 - 14.5</td><td>32 - 33</td></tr>
                          <tr><td><b>M</b></td><td>38 - 40</td><td>32 - 34</td><td>15 - 15.4</td><td>33 - 34</td></tr>
                          <tr><td><b>L</b></td><td>41 - 46</td><td>35 - 37</td><td>16 - 16.5</td><td>34 - 35</td></tr>
                          <tr><td><b>XL</b></td><td>44 - 46</td><td>38 - 40</td><td>17 - 17.5</td><td>35 - 36</td></tr>
                          <tr><td><b>XXL</b></td><td>47 - 49</td><td>41 - 43</td><td>18 - 18.5</td><td>35 - 37</td></tr>
                        </>
                      ) : (
                        <>
                          <tr><td><b>XS</b></td><td>81 - 86</td><td>66 - 71</td><td>33 - 34</td><td>79 - 81</td></tr>
                          <tr><td><b>S</b></td><td>89 - 94</td><td>74 - 79</td><td>36 - 37</td><td>81 - 84</td></tr>
                          <tr><td><b>M</b></td><td>97 - 102</td><td>81 - 86</td><td>38 - 39</td><td>84 - 86</td></tr>
                          <tr><td><b>L</b></td><td>104 - 117</td><td>89 - 94</td><td>41 - 42</td><td>86 - 89</td></tr>
                          <tr><td><b>XL</b></td><td>112 - 117</td><td>97 - 102</td><td>43 - 44</td><td>89 - 91</td></tr>
                          <tr><td><b>XXL</b></td><td>119 - 124</td><td>104 - 109</td><td>46 - 47</td><td>89 - 94</td></tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Shirt Size Chart */}
            <div className="sc-card mt-4">
              <div className="sc-card-header">
                <h4>CANDIDMEN SHIRT SIZE CHART</h4>
              </div>
              <div className="sc-card-body text-center">
                <p className="fs-14 fw-500">
                  Sizes Mentioned In (<span className="unit-text">{unit === 'inch' ? 'Inches' : 'Centimeters'}</span>)
                </p>

                <div className="table-responsive">
                  <table className="table table-striped table-bordered table-w-380">
                    <thead>
                      <tr>
                        <th>Size</th>
                        <th>Chest</th>
                        <th>Sleeve</th>
                      </tr>
                    </thead>
                    <tbody className={unit === 'inch' ? 'inch-values' : 'cm-values'}>
                      {unit === 'inch' ? (
                        <>
                          <tr><td><b>XS</b></td><td>32 - 34</td><td>33.5</td></tr>
                          <tr><td><b>S</b></td><td>35 - 37</td><td>34.5</td></tr>
                          <tr><td><b>M</b></td><td>38 - 40</td><td>35.5</td></tr>
                          <tr><td><b>L</b></td><td>41 - 46</td><td>36.5</td></tr>
                          <tr><td><b>XL</b></td><td>44 - 46</td><td>37.5</td></tr>
                          <tr><td><b>XXL</b></td><td>47 - 49</td><td>38.5</td></tr>
                        </>
                      ) : (
                        <>
                          <tr><td><b>XS</b></td><td>81 - 86</td><td>85</td></tr>
                          <tr><td><b>S</b></td><td>89 - 94</td><td>88</td></tr>
                          <tr><td><b>M</b></td><td>97 - 102</td><td>90</td></tr>
                          <tr><td><b>L</b></td><td>104 - 117</td><td>93</td></tr>
                          <tr><td><b>XL</b></td><td>112 - 117</td><td>95</td></tr>
                          <tr><td><b>XXL</b></td><td>119 - 124</td><td>98</td></tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Pant Size Chart */}
            <div className="sc-card mt-4">
              <div className="sc-card-header">
                <h4>CANDIDMEN PANT SIZE CHART</h4>
              </div>
              <div className="sc-card-body text-center">
                <p className="fs-14 fw-500">
                  Sizes Mentioned In (<span className="unit-text">{unit === 'inch' ? 'Inches' : 'Centimeters'}</span>)
                </p>

                <div className="table-responsive">
                  <table className="table table-striped table-bordered table-w-380">
                    <thead>
                      <tr>
                        <th>Size</th>
                        <th>Waist</th>
                        <th>Inseam</th>
                      </tr>
                    </thead>
                    <tbody className={unit === 'inch' ? 'inch-values' : 'cm-values'}>
                      {unit === 'inch' ? (
                        <>
                          <tr><td><b>XS</b></td><td>26 - 28</td><td>30</td></tr>
                          <tr><td><b>S</b></td><td>29 - 31</td><td>31</td></tr>
                          <tr><td><b>M</b></td><td>32 - 34</td><td>32</td></tr>
                          <tr><td><b>L</b></td><td>35 - 37</td><td>33</td></tr>
                          <tr><td><b>XL</b></td><td>38 - 40</td><td>34</td></tr>
                          <tr><td><b>XXL</b></td><td>41 - 43</td><td>35</td></tr>
                        </>
                      ) : (
                        <>
                          <tr><td><b>XS</b></td><td>66 - 71</td><td>76</td></tr>
                          <tr><td><b>S</b></td><td>74 - 79</td><td>79</td></tr>
                          <tr><td><b>M</b></td><td>81 - 86</td><td>81</td></tr>
                          <tr><td><b>L</b></td><td>89 - 94</td><td>84</td></tr>
                          <tr><td><b>XL</b></td><td>97 - 102</td><td>86</td></tr>
                          <tr><td><b>XXL</b></td><td>104 - 109</td><td>89</td></tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

const Demo = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div>
      {/* Button to trigger the modal */}
      <button className="btn btn-primary" onClick={toggleModal}>
        View Size Chart
      </button>

      {/* Modal Component */}
      <SizeChartModal isOpen={isModalOpen} toggleModal={toggleModal} />
    </div>
  );
};

export default Demo;
